import React from 'react'
import logo from 'images/dv.png'
import { Done, VerifyAccount, ForgotPassword, CheckEmail, ResetPassword } from '../components'
import { RegisterContainer } from '.'
import FlashMessage from 'components/FlashMessage'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { showFlashMessage, showFlashMessageOnUnexpectedError, isLoadingStatus } from 'actions'
import { connect } from 'react-redux'
import { isUserLogged, isBaseDomain } from 'utils'

import { Route, Redirect } from 'react-router-dom'

import { Box, Card, Space } from 'UILibrary'
import { css } from 'react-emotion'

const imageContainer = css({
  width: { xs: '310px', md: '530px' },
  display: 'flex',
  justifyContent: 'center',
  m: 'auto',
})

const NonAuthenticatedContainer = props => {
  return isUserLogged(props.user) ? (
    <Redirect to="/" />
  ) : (
    <span>
      <Box>
        <Space size="xxl" />
        <Box className={imageContainer}>
          {!isBaseDomain(window.location.hostname) ? (
            //FIXME we can extract this logic to create url somewhere
            <a href={`${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${window.location.port ? ':' + window.location.port : ''}`}>
              <img width="280px" alt="dealvestor_logo" src={logo} />
            </a>
          ) : (
            <Link to="/">
              <img width="280px" alt="dealvestor_logo" src={logo} />
            </Link>
          )}
        </Box>
        <FlashMessage />
        <Space size="xl" />
        <Card width={{ xs: 1, md: '530px' }} m="auto" p={{ xs: 'xs', md: 'l' }}>
          {/*<Route path={`${props.match.path}/signin`} render={() => <SignInContainer title="Sign In" />} /> */}
          <Route path={`${props.match.path}/register`} render={routerProps => <RegisterContainer hidePremium {...props} {...routerProps} />} />
          <Route path={`${props.match.path}/verify`} render={routerProps => <VerifyAccount {...props} {...routerProps} />} />
          <Route path={`${props.match.path}/forgot`} render={routerProps => <ForgotPassword {...props} {...routerProps} />} />
          <Route path={`${props.match.path}/reset`} render={routerProps => <ResetPassword {...props} {...routerProps} />} />
          <Route path={`${props.match.path}/check`} component={CheckEmail} />
          <Route path={`${props.match.path}/done`} component={Done} />
        </Card>
      </Box>
    </span>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user,
    isLoading: state.user.isLoading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showFlashMessage, showFlashMessageOnUnexpectedError, isLoadingStatus }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonAuthenticatedContainer)



// WEBPACK FOOTER //
// ./src/features/authentication/containers/NonAuthenticatedContainer.js